/** Format a "last seen" ISO datetime string into a localized human string */
export function formatLastSeen(iso, t) {
    if (!iso) return "";
    const now = Date.now();
    const then = new Date(iso).getTime();
    const diffMs = now - then;
    const mins = Math.floor(diffMs / 60000);
    if (mins < 2) return t("online");
    if (mins < 60) return t("lastSeenMinutes").replace("{n}", mins);
    const hours = Math.floor(mins / 60);
    if (hours < 24) return t("lastSeenHours").replace("{n}", hours);
    const days = Math.floor(hours / 24);
    return t("lastSeenDays").replace("{n}", days);
}

export function isOnline(iso) {
    if (!iso) return false;
    return Date.now() - new Date(iso).getTime() < 2 * 60 * 1000;
}
